
<div class="modal-dialog confirm-dialog">
  <div class="modal-content" style="min-width:600px;">
    <div class="modal-header">
      <h4 class="modal-title">Possible Resolution</h4>
      <button class="close" type="button" (click)="cancel()">&times;</button>
    </div>
    <div class="modal-body">
      <markdown *ngIf="possibleResolutionUrl" [data]="possibleResolutionUrl"></markdown>
    </div>
  </div>
</div>